import React, { useState, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import classNames from "classnames";
import Sidebar1 from "./sidebar/index";
import { TopNav } from "./navbar";
import useIsMobile from "../hook/use-is-mobile";

const DashboardLayout = () => {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(() => !isMobile);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const sidebarBackgroundCheck = pathname.split("/")[1];
  const [showSidebar, setShowSidebar] = useState(true);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleCloseSidebar = () => {
    setSidebarOpen(false);
  };


  const routesWithoutSidebar = ["/notification", "/create-link"];

  useEffect(() => {
    if (routesWithoutSidebar.includes(pathname)) {
      setShowSidebar(false);
    } else {
      setShowSidebar(true);
    }
  }, [pathname]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        handleCloseSidebar();
      }
    };

    if (sidebarOpen && isMobile) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen, isMobile]);

  // Route-based auto open/close only applies on desktop — on mobile the
  // drawer should stay closed by default no matter which route this is.
  useEffect(() => {
    if (isMobile) return;
    if (
      [
        "cpas-dashboard",
        "resseler",
        "automations",
        "campaigns",

      ].includes(sidebarBackgroundCheck)
    ) {
      setSidebarOpen(true);
    } else {
      setSidebarOpen(false);
    }
  }, [sidebarBackgroundCheck, isMobile]);

  // Whenever the viewport crosses INTO mobile (initial load or resize), force
  // the drawer closed — the effect above only owns the desktop case.
  useEffect(() => {
    if (isMobile) setSidebarOpen(false);
  }, [isMobile]);


  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <div className="mx-auto flex min-h-screen bg-[#F1F5F9] dark:bg-gray-950 md:h-screen overflow-hidden">
      {/* Backdrop — mobile only, shown while the drawer is open (menu toggle now lives in TopNav) */}
      {showSidebar && sidebarOpen && isMobile && (
        <div className="fixed inset-0 bg-black/40 z-30 md:hidden" onClick={handleCloseSidebar} />
      )}

      {/* Sidebar */}
      {showSidebar && (
        <aside
          ref={sidebarRef}
          className={classNames(
            "transition-all duration-300 fixed md:static z-40 mx-5 my-5 rounded-md bg-white dark:bg-gray-900 h-[calc(100vh-2.5rem)] md:h-[calc(100vh-2.5rem)]",
            {
              "w-[260px] left-0": sidebarOpen,
              "-left-full w-[58px]": !sidebarOpen, // hide it when closed
            }
          )}
        >
          <div ref={dropdownRef}>
            {sidebarOpen && (
              //   <button className="md:hidden" onClick={toggleSidebar}>
              //     <LogoIcon />
              //   </button>
              <></>
            )}
          </div>

          <Sidebar1 open={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
        </aside>
      )}

      {/* Main Content */}

      <main id="page-scroll-container" className="flex-1  overflow-y-auto">
        <div className="min-h-full p-4">
          <TopNav onMenuClick={toggleSidebar} />
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;